import { BACKGROUND_IMAGE } from '../elements/assets'

export const HERO_COVER_IMAGE = `
...on heroCoverImage_Entry {
  id
  typeHandle
  
  subheading
  heading {
    html
  }
  description

  textAnchor {
    ... on textAnchor_TableRow {
      text
      anchor
    }
  }

  ${ BACKGROUND_IMAGE }
}
`